<template>
    <div>
        <el-form-item :label="$t('标题')">
            <el-input v-model="data.title" placeholder="请输入标题" />
        </el-form-item>
    </div>
</template>

<script>
export default {
    name: "data-auditLog",
    props: ["data"],
    inject: ["formDesign"],
    data() {
        return {};
    },
    mounted() {
        
    },
    methods: {
        
    }
}
</script>
<style scoped>
    
</style>